import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { ApiComponentType } from '@ibe/api';
import React, { JSX } from 'react';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';
import getIconForItemTye from '../Base/getItemForItemType';
import SummaryTabs from '../Base/SummaryTabs';
import Dates from '../Dates';
import InfoContent from './InfoContent';
import Ssrs from './Ssrs';
import fallback from '../../../_Translations/generated/summary.en.t.json';
import Keys from '../../../_Translations/generated/summary.en.t.json.keys';
import useTranslation from '../../../ISO/Hooks//useTranslation';

const Summary = (props: BookedItemComponentProps): JSX.Element => {
  const {
    item,
    isOpen,
    showInfo,
    showTraveler,
    booking,
    onDelete,
    order,
    customPriceModifier,
    showNumberOfPerson,
    showPricePlusMinus
  } = props;

  const icon = getIconForItemTye(item.itemType);
  const { t } = useTranslation('summary', fallback, Keys);

  const numberOfPersonLabel = showNumberOfPerson
    ? t(Keys.numberOfPerson, {
        count: Object.keys(item.priceByPersonId).length,
        numberOfPerson: Object.keys(item.priceByPersonId).length
      })
    : '';

  const mainItem = booking.bookedItems.find(
    bookedItem =>
      bookedItem.relatedBookedItemId &&
      bookedItem.relatedBookedItemId === item.id &&
      bookedItem.componentType === ApiComponentType.MAIN
  );

  const customPrice = customPriceModifier && customPriceModifier(item);
  return (
    <SummaryItem
      title={item.name || ''}
      price={customPrice || item.price}
      subtitle={item.itemType}
      description={mainItem ? mainItem.name : item.description}
      icon={<Icon icon={icon} />}
      dates={<Dates item={item} />}
      isOpen={isOpen}
      onDelete={onDelete}
      booking={booking}
      item={item}
      order={order?.Package}
      numberOfPerson={numberOfPersonLabel}
      showPricePlusMinus={showPricePlusMinus}
    >
      {(showInfo || showTraveler) && (
        <SummaryTabs
          booking={booking}
          item={item}
          info={<InfoContent booking={booking} item={item} />}
          showInfo={showInfo}
          showTraveler={showTraveler}
          showSsr
          ssrs={<Ssrs booking={booking} bookedItem={item} />}
        />
      )}
    </SummaryItem>
  );
};

export default Summary;
